/**
 * Muscle Grenade — Portal de cuenta
 */
(function () {
  'use strict';

  var hub = document.querySelector('[data-mg-acc-hub]');
  if (hub) {
    var tabs = hub.querySelectorAll('[data-acc-tab]');
    var panels = hub.querySelectorAll('[data-acc-panel]');
    var saved = null;
    try { saved = localStorage.getItem('mg-acc-tab'); } catch (e) {}

    function activateTab(id) {
      tabs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-acc-tab') === id);
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-acc-panel') === id);
      });
      try { localStorage.setItem('mg-acc-tab', id); } catch (e) {}
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab.getAttribute('data-acc-tab'));
      });
    });

    if (window.location.hash === '#favorites') {
      activateTab('favorites');
    } else if (window.location.hash === '#rewards') {
      activateTab('rewards');
    } else if (window.location.hash === '#profile') {
      activateTab('profile');
    } else if (window.location.hash === '#coach') {
      activateTab('coach');
    } else if (saved) {
      activateTab(saved);
    }

    var favContainer = hub.querySelector('[data-mg-acc-favorites]');

    function renderFavorites() {
      if (!favContainer || !window.MGWishlist || !window.MGWishlist.renderFavorites) return;
      window.MGWishlist.renderFavorites(favContainer);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (tab.getAttribute('data-acc-tab') === 'favorites') {
          setTimeout(renderFavorites, 50);
        }
      });
    });

    if (hub.querySelector('[data-acc-panel="favorites"]').classList.contains('is-active')) {
      setTimeout(renderFavorites, 100);
    }

    var filterBtns = hub.querySelectorAll('[data-order-filter]');
    var orders = hub.querySelectorAll('[data-order-item]');

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = btn.getAttribute('data-order-filter');
        filterBtns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        orders.forEach(function (o) {
          var status = o.getAttribute('data-order-status') || '';
          var show = f === 'all' || status.indexOf(f) >= 0;
          o.style.display = show ? '' : 'none';
        });
      });
    });

    initProfile(hub);
  }

  function initProfile(root) {
    var profile = root.querySelector('[data-mg-profile]');
    if (!profile) return;
    var Prefs = window.MGProfilePrefs;

    root.querySelectorAll('[data-mg-copy-text]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var text = btn.getAttribute('data-mg-copy-text') || '';
        if (!text || !navigator.clipboard) return;
        navigator.clipboard.writeText(text).then(function () {
          var prev = btn.textContent;
          btn.textContent = '✓';
          btn.classList.add('is-copied');
          setTimeout(function () {
            btn.textContent = prev;
            btn.classList.remove('is-copied');
          }, 1600);
        });
      });
    });

    var form = profile.querySelector('[data-mg-profile-prefs]');
    var savedMsg = profile.querySelector('[data-prefs-saved]');
    var summaryEl = profile.querySelector('[data-prefs-summary]');
    var finderLink = profile.querySelector('[data-prefs-finder-link]');
    var finderHint = profile.querySelector('[data-prefs-finder-hint]');
    if (!form || !Prefs) return;

    function renderSummary() {
      var sum = Prefs.summary();
      if (summaryEl && sum) {
        summaryEl.hidden = false;
        var when = sum.updatedAt ? new Date(sum.updatedAt).toLocaleDateString('es-CL') : '';
        summaryEl.innerHTML =
          '<strong>Tu perfil deportivo</strong>' +
          '<span>' + sum.goal + ' · ' + sum.level + ' · ' + sum.budget + '</span>' +
          (when ? '<small>Actualizado ' + when + (Prefs.load()?.source === 'fit-finder' ? ' · desde Fit Finder' : '') + '</small>' : '');
      } else if (summaryEl) {
        summaryEl.hidden = true;
      }

      if (finderLink && Prefs.isComplete()) {
        finderLink.href = finderLink.href.split('?')[0] + '?from=profile&autostart=1';
        finderLink.textContent = '🎯 Ver mis recomendaciones Fit Finder →';
        if (finderHint) finderHint.hidden = true;
      } else if (finderHint) {
        finderHint.hidden = false;
      }
    }

    var prefs = Prefs.load();
    if (prefs) {
      ['goal', 'level', 'budget'].forEach(function (name) {
        var el = form.elements[name];
        if (el && prefs[name]) el.value = prefs[name];
      });
      if (form.elements.notify_offers) {
        form.elements.notify_offers.checked = !!prefs.notify_offers;
      }
    } else if (window.MG_CUSTOMER && window.MG_CUSTOMER.acceptsMarketing && form.elements.notify_offers) {
      form.elements.notify_offers.checked = true;
    }

    try {
      var finderResult = localStorage.getItem('mg-finder-result');
      if (finderResult && !prefs) {
        Prefs.fromFinderAnswers(JSON.parse(finderResult));
        prefs = Prefs.load();
        if (prefs) {
          ['goal', 'level', 'budget'].forEach(function (name) {
            var el = form.elements[name];
            if (el && prefs[name]) el.value = prefs[name];
          });
        }
      }
    } catch (e) {}

    renderSummary();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      Prefs.save({
        goal: form.elements.goal ? form.elements.goal.value : '',
        level: form.elements.level ? form.elements.level.value : '',
        budget: form.elements.budget ? form.elements.budget.value : '',
        notify_offers: form.elements.notify_offers ? form.elements.notify_offers.checked : false,
        source: 'profile'
      });

      if (savedMsg) {
        savedMsg.hidden = false;
        setTimeout(function () { savedMsg.hidden = true; }, 2800);
      }

      renderSummary();

      var pct = parseInt(profile.getAttribute('data-profile-pct') || '0', 10);
      if (Prefs.isComplete()) {
        var fill = profile.querySelector('[data-profile-pct-fill]');
        var label = profile.querySelector('[data-profile-pct-label]');
        var display = Math.min(100, pct + 5);
        if (fill) fill.style.width = display + '%';
        if (label) label.textContent = display + '%';
      }
    });
  }

  var auth = document.querySelector('[data-mg-acc-auth]');
  if (auth) {
    var showRecover = function (e) {
      if (e) e.preventDefault();
      auth.querySelector('.mg-acc-auth__recover').classList.add('is-visible');
      var login = auth.querySelector('.mg-acc-auth__login');
      if (login) login.classList.add('is-hidden');
    };
    var hideRecover = function (e) {
      if (e) e.preventDefault();
      auth.querySelector('.mg-acc-auth__recover').classList.remove('is-visible');
      var login = auth.querySelector('.mg-acc-auth__login');
      if (login) login.classList.remove('is-hidden');
    };

    auth.querySelectorAll('[data-show-recover]').forEach(function (el) {
      el.addEventListener('click', showRecover);
    });
    auth.querySelectorAll('[data-hide-recover]').forEach(function (el) {
      el.addEventListener('click', hideRecover);
    });

    if (window.location.hash === '#recover') showRecover();
  }
})();